import { render, staticRenderFns } from "./UreaExcretionFraction.vue?vue&type=template&id=3c74ee18&scoped=true"
import script from "./UreaExcretionFraction.vue?vue&type=script&lang=js"
export * from "./UreaExcretionFraction.vue?vue&type=script&lang=js"
import style0 from "./UreaExcretionFraction.vue?vue&type=style&index=0&id=3c74ee18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c74ee18",
  null
  
)

export default component.exports